// removed by extract-text-webpack-plugin
module.exports = {"gw_multiselect_container":"multiselect-hashed__gw_multiselect_container__3wHsw"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/multiselect/components/multiselect/multiselect-hashed.scss
// module id = 705
// module chunks = 0